import script from "./changePath.vue?vue&type=script&setup=true&lang=ts"
export * from "./changePath.vue?vue&type=script&setup=true&lang=ts"

import "./changePath.vue?vue&type=style&index=0&id=06d84ee6&scoped=true&lang=scss"
import "./changePath.vue?vue&type=style&index=1&id=06d84ee6&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06d84ee6"]])

export default __exports__